var map = {
	"./academy/templates/js/setup.js": 66618,
	"./affiliate/templates/js/setup.js": 48879,
	"./kanoon/templates/js/setup.js": 86917,
	"./learning/templates/js/setup.js": 11302,
	"./system/templates/js/setup.js": 40694,
	"./user/templates/js/setup.js": 93250
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 56246;